import {createSlice} from "@reduxjs/toolkit";

const pos = createSlice({
    name: "pos",
    initialState: {
        tabs: [
            {
                id: 1,
                name: 'Hóa đơn 1',
                customer: null,
                items: [],
                discount: 0,
                discountType: 'amount', // 'amount' or 'percent'
                shipping: 0,
                paid: 0,
                isPaidManuallySet: false, // Track if user manually changed paid amount
                paymentMethod: 'cash', // 'cash' or 'transfer'
                qrCodeUrl: '', // QR code URL for transfer payment
            }
        ],
        activeTab: 1,
        nextTabId: 2,
    },
    reducers: {
        addTab(state) {
            const newTab = {
                id: state.nextTabId,
                name: `Hóa đơn ${state.nextTabId}`,
                customer: null,
                items: [],
                discount: 0,
                discountType: 'amount',
                shipping: 0,
                paid: 0,
                isPaidManuallySet: false, // Track if user manually changed paid amount
                paymentMethod: 'cash', // 'cash' or 'transfer'
                qrCodeUrl: '', // QR code URL for transfer payment
            };
            state.tabs.push(newTab);
            state.activeTab = state.nextTabId;
            state.nextTabId += 1;
            return state;
        },
        removeTab(state, action) {
            const tabId = action.payload;
            state.tabs = state.tabs.filter(tab => tab.id !== tabId);
            if (state.activeTab === tabId && state.tabs.length > 0) {
                state.activeTab = state.tabs[0].id;
            }
            return state;
        },
        setActiveTab(state, action) {
            state.activeTab = action.payload;
            return state;
        },
        setCustomer(state, action) {
            const {tabId, customer} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.customer = customer;
            }
            return state;
        },
        addItem(state, action) {
            const {tabId, item} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                const existingItem = tab.items.find(i => i.id === item.id);
                if (existingItem) {
                    // If item already exists, increase by step (0.1 for kg, 1 for others)
                    const step = item.unit === 'kg' ? 0.1 : 1;
                    existingItem.quantity += step;
                } else {
                    // Use quantity from item if provided, otherwise default to 1
                    const initialQuantity = item.quantity !== undefined ? item.quantity : 1;
                    tab.items.push({...item, quantity: initialQuantity});
                }
            }
            return state;
        },
        updateItemQuantity(state, action) {
            const {tabId, itemId, quantity} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                const item = tab.items.find(i => i.id === itemId);
                if (item) {
                    item.quantity = quantity;
                }
            }
            return state;
        },
        updateItemPrice(state, action) {
            const {tabId, itemId, price} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                const item = tab.items.find(i => i.id === itemId);
                if (item) {
                    item.price = price;
                }
            }
            return state;
        },
        removeItem(state, action) {
            const {tabId, itemId} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.items = tab.items.filter(i => i.id !== itemId);
            }
            return state;
        },
        setDiscount(state, action) {
            const {tabId, discount, discountType} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.discount = discount;
                if (discountType) tab.discountType = discountType;
            }
            return state;
        },
        setShipping(state, action) {
            const {tabId, shipping} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.shipping = shipping;
            }
            return state;
        },
        setPaid(state, action) {
            const {tabId, paid, isManual} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.paid = paid;
                // If isManual is explicitly provided, use it; otherwise default to true
                if (isManual !== undefined) {
                    tab.isPaidManuallySet = isManual;
                } else {
                    tab.isPaidManuallySet = true;
                }
            }
            return state;
        },
        setPaymentMethod(state, action) {
            const {tabId, paymentMethod} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.paymentMethod = paymentMethod;
            }
            return state;
        },
        setQrCodeUrl(state, action) {
            const {tabId, qrCodeUrl} = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.qrCodeUrl = qrCodeUrl;
            }
            return state;
        },
        clearTab(state, action) {
            const tabId = action.payload;
            const tab = state.tabs.find(t => t.id === tabId);
            if (tab) {
                tab.customer = null;
                tab.items = [];
                tab.discount = 0;
                tab.discountType = 'amount';
                tab.shipping = 0;
                tab.paid = 0;
                tab.isPaidManuallySet = false;
                tab.paymentMethod = 'cash';
                tab.qrCodeUrl = ''; // Clear QR code
            }
            return state;
        },
        restoreState(state, action) {
            const { tabs, activeTab, nextTabId } = action.payload;
            state.tabs = tabs || state.tabs;
            state.activeTab = activeTab || state.activeTab;
            state.nextTabId = nextTabId || state.nextTabId;
            return state;
        }
    }
});

//Action
export const posActions = pos.actions;
//Reducers
export const posReducer = pos.reducer;
//Selectors
export const posTabsSelector = (state) => state.pos.tabs;
export const posActiveTabSelector = (state) => state.pos.activeTab;
export const posActiveTabDataSelector = (state) => {
    const activeTabId = state.pos.activeTab;
    return state.pos.tabs.find(t => t.id === activeTabId);
};
